module.exports = __webpack_public_path__ + "img/Group 427320374.426e9074.svg";